import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';
import type { Price } from '@noths/polaris-dev-ts-types';
import getConfig from 'next/config';
import qs from 'querystring';

import type { NextConfig } from 'src/types/nextConfig';
import type { DeliverySettingsAPIDeliveryZone } from './types/DeliverySettingsAPIDeliveryZone';

const { publicRuntimeConfig } = getConfig() as NextConfig;

// Swagger docs: https://delivery-settings.svc.qa.noths.com/swagger-ui.html#/multiple-zone-delivery-price-and-date-resource
export const fetchDeliveryOptions = async (productCode: number, price: Price) => {
  const DELIVERY_OPTIONS_ENDPOINT = publicRuntimeConfig.endpoints.deliverySettings;
  const { amount, currency } = price;

  const formattedAmount = new Intl.NumberFormat('en-GB', {
    style: 'decimal',
    minimumFractionDigits: 2,
  })
    .format(amount / 100)
    .replace(',', '');

  const querystring = qs.encode({
    amount: formattedAmount,
    currency,
  });
  const url = `${DELIVERY_OPTIONS_ENDPOINT}v2/products/${productCode}/multiple-zone-delivery-options?${querystring}`;
  const response = await fetchJSONWithTimeout(url, { timeout: 2000 });

  if (!response.ok) {
    throw new Error(`Failed to fetch delivery options: ${response.status} ${response.statusText}`);
  }

  const deliveryOptions: DeliverySettingsAPIDeliveryZone[] = await response.json();

  return deliveryOptions;
};
